import CheckIcon from "@mui/icons-material/Check";
import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import type { StraightenerParameterRow } from "../models/StraightenerParamLimit";

interface Props {
	rows: StraightenerParameterRow[];
	selectedCode: string | null;
	onSelect: (row: StraightenerParameterRow) => void;
}

const fmt = (n: number | null): string => (n == null ? "—" : String(n));

const headCellSx = {
	fontWeight: 700,
	fontSize: "0.75rem",
	color: "text.secondary",
	py: 1,
};

const check = (v: boolean) =>
	v ? <CheckIcon sx={{ fontSize: 16, color: "success.main" }} /> : null;

export const StraightenerLimitsTable = ({
	rows,
	selectedCode,
	onSelect,
}: Props) => (
	<Box sx={{ height: "100%", overflow: "auto" }}>
		<Table stickyHeader size="small">
			<TableHead>
				<TableRow>
					<TableCell sx={headCellSx}>Parameter</TableCell>
					<TableCell sx={headCellSx}>Section</TableCell>
					<TableCell sx={headCellSx} align="center">
						To PLC
					</TableCell>
					<TableCell sx={headCellSx} align="center">
						Required
					</TableCell>
					<TableCell sx={headCellSx} align="right">
						Min
					</TableCell>
					<TableCell sx={headCellSx} align="right">
						Max
					</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{rows.map((r) => {
					const selected = r.code === selectedCode;
					return (
						<TableRow
							key={r.code}
							hover
							selected={selected}
							onClick={() => onSelect(r)}
							sx={{ cursor: "pointer" }}
						>
							<TableCell>
								<Typography variant="body2" sx={{ fontWeight: 600 }}>
									{r.displayName}
								</Typography>
							</TableCell>
							<TableCell>
								<Typography variant="body2" color="text.secondary">
									{r.group}
								</Typography>
							</TableCell>
							<TableCell align="center">{check(r.sendToPlc)}</TableCell>
							<TableCell align="center">{check(r.isRequired)}</TableCell>
							<TableCell align="right">{fmt(r.min)}</TableCell>
							<TableCell align="right">{fmt(r.max)}</TableCell>
						</TableRow>
					);
				})}
				{rows.length === 0 ? (
					<TableRow>
						<TableCell
							colSpan={6}
							align="center"
							sx={{ color: "text.secondary" }}
						>
							No parameters match the search.
						</TableCell>
					</TableRow>
				) : null}
			</TableBody>
		</Table>
	</Box>
);
